/* unplugin-vue-components disabled */import { render } from "./communityBlog.vue?vue&type=template&id=aeabf9f0&scoped=true"
import script from "./communityBlog.vue?vue&type=script&lang=js"
export * from "./communityBlog.vue?vue&type=script&lang=js"

import "./communityBlog.vue?vue&type=style&index=0&id=aeabf9f0&lang=sass&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeabf9f0"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
